export default "__VITE_ASSET__Ca8j3DkP__"